import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { EMPTY, Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';

export type FavouriteType = 'POST' | 'BLOG' | 'EVENT';

export interface IFavouriteToggleResult {
  isFavourite: boolean;
}

export interface IFavouritePage {
  items: any[];
  total: number;
  page: number;
  limit: number;
}

@Injectable({ providedIn: 'root' })
export class FavouriteService {
  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);
  private baseUrl = `${environment.apiUrl}/favourites`;

  /** Emits whenever a favourite is toggled so components can react */
  private toggle$ = new Subject<{ contentId: string; isFavourite: boolean }>();
  onToggle$ = this.toggle$.asObservable();

  /** Toggle favourite status for a content item */
  toggle(contentId: string): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;
    return this.http.post(`${this.baseUrl}/${contentId}`, {});
  }

  /** Get current user's favourites, optionally filtered by type */
  getFavourites(page = 1, limit = 10, type?: FavouriteType): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    if (type) params = params.set('type', type);
    return this.http.get(this.baseUrl, { params });
  }

  /** Check which of the given content IDs are favourited */
  checkFavourites(contentIds: string[]): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;
    return this.http.post(`${this.baseUrl}/check`, { contentIds });
  }

  /** Broadcast a toggle result to all subscribers */
  broadcastToggle(contentId: string, isFavourite: boolean): void {
    this.toggle$.next({ contentId, isFavourite });
  }
}
